import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Login from "../pages/Login";
import Sso from "../pages/Sso";
import SideBar from "../components/Sidebar";
import { Roles } from "../utils/constants";
import {
  FOREMAN_AND_GENERAL_FOREMAN_ROUTES,
  FOREMAN_ROUTES,
  GENERAL_FOREMAN_ROUTES,
  OPS_MANAGER_ROUTES,
  ROUTES,
  NO_DATA_ROUTES,
  LOGIN_ROUTES,
  RESET_PASSWORD_ROUTES,
  FOREMAN_AND_OPS_MANAGER_ROUTES,
  GENERAL_FOREMAN_AND_OPS_MANAGER_ROUTES,
  CHECKLIST_APPROVER_ROUTES,
  CHECKLIST_APPROVER_REVIEW_ROUTES
} from "../utils/routes";
import TimeCard from "../pages/TimeCard";
import TimeCards from "../pages/TimeSheetStatus";
import ForgetPassword from "../pages/ForgetPassword";
import ChangePassword from "../pages/ChangePassword";
import { checkToken } from "../utils/apiUtils";
import { useEffect, useState } from "react";
import Header from "../components/Header";
import PushNudgeBanner from "../components/PushNudgeBanner";
function AuthRoute({ children, userroles }) {
  const navigate = useNavigate();
  const location = useLocation();

  const accessToken = localStorage.getItem("accessToken");
  let role_id;

  if (localStorage.getItem("role_id")) {
    role_id = JSON.parse(localStorage.getItem("role_id"));
  }

  const role = localStorage.getItem("role_name");

  const currentRoleAccess = Roles[role_id];

  if (!role) {
    //Not signed in
    return <Navigate to="/" />;
  }
  //Signed in
  if (role_id) {
    if (userroles.includes(currentRoleAccess) || userroles.includes("all")) {
      return (
        <>
          {" "}
          {/* <SideBar /> */}
          {children}
        </>
      );
    } else {
      return <Navigate to="/projects" />;
    }
  } else {
    return <Navigate to="/" />;
  }
}

function Routing() {
  const [token, setToken] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  const urlToken = location?.pathname?.split("/")[2];

  const isToken = async () => {
    const userToken = await checkToken(urlToken);
    setToken(userToken);
  };

  useEffect(() => {
    if (location.pathname.includes("/reset_password")) {
      isToken();
    }
    if (location.pathname.includes("/activate_account")) {
      isToken();
    }
  }, []);

  const accessToken = localStorage.getItem("accessToken");
  const role = localStorage.getItem("role_name");
  const isChecklistApprover = JSON.parse(
    localStorage.getItem("checklist_approver") || "false"
  );
  return (
    <>
      {accessToken && <Header />}
      {/* PUSH-NUDGE-001 — full-width strip under the header, not inside any dropdown, so
          it's mounted at this level rather than inside Header itself. */}
      {accessToken && <PushNudgeBanner />}
      {/* Code review F5 — a dismissible focus target: PushNudgeBanner moves focus here
          (`#wt-main-content`) on "Not now" and on its 4s auto-hide, before it unmounts
          itself, so keyboard/screen-reader focus never falls back to <body>.
          `tabIndex={-1}` makes it programmatically focusable without adding it to the tab
          order. */}
      <main className="main" id="wt-main-content" tabIndex={-1}>
        <div className={`right-content`}>
          <Routes>
            <Route path="/sso" element={<Sso />} />
            {/* {!role &&
            !token &&
            (!location.pathname.includes("/reset_password") ||
              !location.pathname.includes("/activate_account"))
              ? Object.values(LOGIN_ROUTES).map((route) => {
                  console.log("routeroute", route);
                  return (
                    <Route
                      key={route.path}
                      path={route.path}
                      element={route.element}
                    />
                  );
                })
              : Object.values(RESET_PASSWORD_ROUTES).map((route) => {
                  console.log("routeroute", route);
                  return (
                    <Route
                      key={route.path}
                      path={route.path}
                      element={route.element}
                    />
                  );
                })} */}

            {!role && (
              <Route path="/forget-password" element={<ForgetPassword />} />
            )}
            {token && location.pathname.includes("/reset_password") && (
              <Route
                path="/reset_password/:token?"
                element={<ChangePassword />}
              />
            )}
            {/* {!role && !token && <Route path="*" element={<Navigate to="/" replace />} />} */}
            {!role && <Route path="/" element={<Login />} />}
            {token && location.pathname.includes("/activate_account") && (
              <Route
                path="/activate_account/:token?"
                element={<ChangePassword />}
              />
            )}
            {role === "Admin" &&
              Object.values(ROUTES).map((route) => {
                return (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={
                      <AuthRoute userroles={route?.availability}>
                        {route.element}
                      </AuthRoute>
                    }
                  />
                );
              })}
            {role === "Ops Manager" &&
              Object.values(OPS_MANAGER_ROUTES).map((route) => {
                return (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={
                      <AuthRoute userroles={route?.availability}>
                        {route.element}
                      </AuthRoute>
                    }
                  />
                );
              })}

            {role === "Foreman" &&
              Object.values(FOREMAN_ROUTES).map((route) => {
                return (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={
                      <AuthRoute userroles={route?.availability}>
                        {route.element}
                      </AuthRoute>
                    }
                  />
                );
              })}

            {/* Checklist approvers view all timesheets on top of their crew
                role. Foreman is the only crew role missing these routes. */}
            {role === "Foreman" &&
              isChecklistApprover &&
              Object.values(CHECKLIST_APPROVER_REVIEW_ROUTES).map((route) => {
                return (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={
                      <AuthRoute userroles={route?.availability}>
                        {route.element}
                      </AuthRoute>
                    }
                  />
                );
              })}

            {role === "General Foreman" &&
              Object.values(GENERAL_FOREMAN_ROUTES).map((route) => {
                return (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={
                      <AuthRoute userroles={route?.availability}>
                        {route.element}
                      </AuthRoute>
                    }
                  />
                );
              })}

            {role === "Foreman GeneralForeman" &&
              Object.values(FOREMAN_AND_GENERAL_FOREMAN_ROUTES).map((route) => {
                return (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={
                      <AuthRoute userroles={route?.availability}>
                        {route.element}
                      </AuthRoute>
                    }
                  />
                );
              })}

            {role === "Foreman OpsManager" &&
              Object.values(FOREMAN_AND_OPS_MANAGER_ROUTES).map((route) => {
                return (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={
                      <AuthRoute userroles={route?.availability}>
                        {route.element}
                      </AuthRoute>
                    }
                  />
                );
              })}

            {role === "GeneralForeman Ops Manager" &&
              Object.values(GENERAL_FOREMAN_AND_OPS_MANAGER_ROUTES).map((route) => {
                return (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={
                      <AuthRoute userroles={route?.availability}>
                        {route.element}
                      </AuthRoute>
                    }
                  />
                );
              })}

            {role === "User" &&
              Object.values(NO_DATA_ROUTES).map((route) => {
                return (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={
                      <AuthRoute userroles={route?.availability}>
                        {route.element}
                      </AuthRoute>
                    }
                  />
                );
              })}

            {role === "Checklist Approver" &&
              Object.values(CHECKLIST_APPROVER_ROUTES).map((route) => {
                return (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={
                      <AuthRoute userroles={route?.availability}>
                        {route.element}
                      </AuthRoute>
                    }
                  />
                );
              })}
          </Routes>
        </div>
      </main>
    </>
  );
}

export default Routing;
